import loginLogo from '../../assets/images/adas-intelligence-login-logo.svg'
import PropTypes from 'prop-types'

// Public-page frame shared by the sign-up screens: the same navy gradient + hex pattern as the
// login and password-reset pages, with a glass card whose width the step chooses.
// `plans` fits four plan cards side by side with room for their copy.
const WIDTHS = { narrow: 'max-w-[420px]', form: 'max-w-[640px]', wide: 'max-w-[980px]', plans: 'max-w-[1440px]' }

export const RegistrationShell = ({ width = 'form', title, subtitle, children }) => (
  <div
    className='flex min-h-screen w-full items-start justify-center py-6'
    style={{
      background: 'linear-gradient(135deg, #0A1628 0%, #0F2035 40%, #132B45 70%, #0A1628 100%)',
      backgroundSize: 'cover'
    }}
  >
    <div
      className='pointer-events-none fixed inset-0 opacity-[0.06]'
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56' height='100' viewBox='0 0 56 100'%3E%3Cpath d='M28 66L0 50L0 16L28 0L56 16L56 50L28 66ZM28 100L0 84L0 50L28 34L56 50L56 84L28 100Z' fill='none' stroke='%23ffffff' stroke-width='0.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }}
    />
    <div className={`relative z-10 w-full transition-[max-width] duration-300 ${WIDTHS[width] ?? WIDTHS.form} px-4`}>
      <div className='rounded-2xl border border-white/[0.08] bg-white/[0.04] p-8 shadow-2xl backdrop-blur-md'>
        <div className='mb-5 flex flex-col items-center'>
          <img src={loginLogo} alt='ADAS Intelligence' width={200} style={{ width: 200, height: 'auto', display: 'block' }} />
          {title && <h1 className='mt-4 text-center text-[20px] font-bold text-white'>{title}</h1>}
          {subtitle && <p className='mt-1 max-w-[60ch] text-center text-[13px] text-white/60'>{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  </div>
)
RegistrationShell.propTypes = {
  width: PropTypes.oneOf(['narrow', 'form', 'wide', 'plans']),
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node
}

// Form primitives in the login page's visual language.
export const fieldClass =
  'w-full h-11 rounded-xl bg-white/[0.12] backdrop-blur-sm border border-white/[0.15] px-4 text-white text-sm placeholder:text-white/45 outline-none focus:border-white/40 focus:bg-white/[0.18] transition-colors'
export const fieldErrorClass = 'border-red-400/60'
export const labelClass = 'mb-1 block text-[11px] font-semibold uppercase tracking-wide text-white/55'
export const primaryButtonClass =
  'flex min-h-12 w-full items-center justify-center rounded-full px-6 py-2 text-center leading-tight bg-gradient-to-r from-[#1F6FEB] to-[#1F6FEB] text-sm font-bold uppercase tracking-widest text-white shadow-lg shadow-blue-500/25 transition-all hover:shadow-blue-500/40 hover:brightness-110 active:scale-[0.98] disabled:opacity-60 disabled:pointer-events-none'
export const linkButtonClass = 'text-[12px] text-white/55 hover:text-white/85 transition-colors'

export const ErrorBox = ({ children }) => (
  <div role='alert' className='rounded-lg border border-red-400/20 bg-red-500/10 px-4 py-2 text-center text-[12px] text-red-300'>
    {children}
  </div>
)
ErrorBox.propTypes = { children: PropTypes.node }

export const InfoBox = ({ children }) => (
  <div role='status' className='rounded-lg border border-white/10 bg-white/[0.06] px-4 py-3 text-center text-[13px] text-white/80'>
    {children}
  </div>
)
InfoBox.propTypes = { children: PropTypes.node }
